<script>
	import TBoxTrabalhosSDG from './../templates/TBoxTrabalhosSDG.svelte';
	// The params prop contains values matched from the URL
	export let params = {} 
	
	import { replace } from 'svelte-spa-router';
	import { createEventDispatcher, onMount } from 'svelte';
	import { 
		API, 
		TipoEvento,
		StatusHttp, 
		TextoFeedback } from '../../utils';

	const dispatch = createEventDispatcher();
	let apresentacao = {};
	let participantes = [];
	let anexos = [];

	onMount(async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando projeto ...',
		});
		
		const resposta = await fetch(API(`sdg/trabalho/extrato/${params.id}`), {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			console.log(erros);
			replace("#/sdg/trabalhos");
		});
		
		const { dados, status } = await resposta.json();

		if (status == StatusHttp.OK) {
			
			apresentacao = dados;
			participantes = apresentacao.participantes;
			anexos = apresentacao.anexos;
		} else {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			replace('#/resumo-inexistente');

			return;
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});
</script>

<TBoxTrabalhosSDG
	titulo={apresentacao.titulo} 
	subtitulo="{apresentacao.alocacao} &bull; {apresentacao.modalidade} &bull; {apresentacao.unidade}"
	largura="10" 
	deslocamento="1">

	<div class="columns is-mobile">
		<div class="column is-12">
			<span class="tag is-dark is-pulled-right mr-1" title="Número de inscrição">Apresentação {apresentacao.inscricao}</span>
		</div>
	</div>

	<hr>

	<p class="is-size-4 mb-4">Resumo</p>
	<div class="content">
		{@html apresentacao.resumo}
	</div>

	<p class="has-text-centered">
		<span class="tag" title="Data de criação da apresentação (adicionado no sistema)">{apresentacao.data_criacao}</span> &bull; 
		<span class="tag" title="Data da última atualização da apresentação">{apresentacao.data_ultima_atualizacao}</span>
	</p>

	<br>

	{#if anexos?.length > 0}
	<p class="is-size-4 mb-4">Anexos</p>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Tipo</th>
				<th>Valor</th>
			</tr>
		</thead>
		<tbody>
			{#each anexos as anexo, i}
			<tr>
				<th>{ ++i }</th> 
				<td>{ anexo.tipo }</td>
				{#if anexo.valor.trim().startsWith('http')}
				<td><a href="{ anexo.valor.trim() }" target="_blank">{ anexo.valor.trim() }</a></td>
				{:else}
				<td>{ anexo.valor.trim() }</td>
				{/if}
			</tr>
			{/each}
		</tbody>
	</table>
	{/if}
	
	{#if participantes?.length > 0}

	<p class="is-size-4 mb-4">Participantes</p>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Nome</th>
				<th>Unidade</th>
				<th>Papel</th>
			</tr>
		</thead>
		<tbody>
			{#each participantes as participante, i}
			<tr>
				<th>{ ++i }</th> 
				<td class="has-text-primary">{ participante.nome }</td>
				<td>{ participante.unidade }</td>
				<td>{ participante.papel }</td>
			</tr>
			{/each}
		</tbody>
	</table>
	{/if}
</TBoxTrabalhosSDG>